import { render, staticRenderFns } from "./TodayNorthList.vue?vue&type=template&id=672da4c4"
import script from "./TodayNorthList.vue?vue&type=script&lang=js"
export * from "./TodayNorthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports